import { render } from "./ProjectTemplateDownloadPage.vue?vue&type=template&id=2907ad5c&ts=true"
import script from "./ProjectTemplateDownloadPage.vue?vue&type=script&lang=ts"
export * from "./ProjectTemplateDownloadPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__